const state = {
    result: {},
    checkedInvoice: {}
};

const getters = {
    // 是否是电子发票
    getCanShowElecInvoice: state => {
        return state.result.canShowElecInvoice;
    },
    // 电子发票或者普通发票   个人
    getInvoicePerson: state => {
        var brr = state.result.canShowElecInvoice ? state.result.invoicePersonaElec : state.result.invoicePersonaCom;
        if(!brr)return [];
        var arr = JSON.parse(JSON.stringify(brr))
        for (var i in arr) {
            arr[i].invoiceInfo = ' ' + arr[i].invoiceInfo;
        }
        return arr;
    },
    // 电子发票或者普通发票   公司
    getInvoiceCompany: state => {
        var brr = state.result.canShowElecInvoice ? state.result.invoiceCompanyElec : state.result.invoiceCompanyCom;
        if(!brr)return [];
        var arr = JSON.parse(JSON.stringify(brr))
        for (var i in arr) {
            arr[i].invoiceInfo = ' ' + arr[i].invoiceInfo;
        }
        return arr;
    },
    // 增值税发票(增加空格是解决input输入框唤醒键盘后，input内容为空的话，点击以前的发票信息无法获取点击事件，但是有个空格就可以获取。。。。。。。。。最后在保存发票信息是，trim()去掉空格)
    getIinvoiceTax: state => {
        if(!state.result.invoiceTax)return [];
        var arr = JSON.parse(JSON.stringify(state.result.invoiceTax))
        for (var i in arr) {
            arr[i].invoiceInfo = ' ' + arr[i].invoiceInfo;
        }
        return arr;
    },
    getCheckedInvoice: state => {
        return state.checkedInvoice;
    }
};

const mutations = { 
    changeCheckedInvoice(state, payload) {
        state.checkedInvoice = payload
    },
    comState(state, payload){
        state.result = payload
    }
};

const actions = { 
    disCheckedInvoice({ commit }, reqData) {
        commit("changeCheckedInvoice", reqData);
    },
    disState({ commit }, reqData) {
        commit("comState", reqData);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};